import script from "./qr.vue?vue&type=script&setup=true&lang=js"
export * from "./qr.vue?vue&type=script&setup=true&lang=js"

import "./qr.vue?vue&type=style&index=0&id=602959fa&lang=css"

const __exports__ = script;

export default __exports__